(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mms-creator-modal"] && !Shopify.designMode) return;
  try {
    ;(function () {
    const modal = document.getElementById('mmsCreatorModal')
    if (!modal) return
    const iframe = modal.querySelector('[data-mms-creator-iframe]')
    const loader = modal.querySelector('[data-mms-creator-loader]')
    const iframeOrigin = 'https://creator.mamamiya.store'
    const iframeUrl = iframeOrigin + '/?embed=1'
    let iframeBooted = false

    function sendAuth() {
      // Post AUTH handoff to creator origin so it can correlate session with
      // the Shopify customer (creator-hub main.js listens for trusted-origin AUTH)
      try {
        const token = localStorage.getItem('mms_customer_token')
        if (token) {
          iframe.contentWindow.postMessage({ type: 'AUTH', token: token }, iframeOrigin)
        }
      } catch (_) {
        /* SSR / private mode — ignore */
      }
      // H-147: hint the Shopify customer's email so creator-hub can pre-fill
      // the sign-in form. UX prefill ONLY — not a credential; hub never
      // treats it as proof of identity. The AUTH postMessage above is kept
      // for backward compatibility. The email rides in a data attribute so
      // this javascript block stays Liquid-free.
      const hintEmail = modal.dataset ? modal.dataset.customerEmail : ''
      if (hintEmail) {
        try {
          iframe.contentWindow.postMessage(
            { type: 'SHOPIFY_CUSTOMER_HINT', email: hintEmail },
            iframeOrigin
          )
        } catch (_) {
          /* ignore */
        }
      }
    }

    // product -> Design mode (lay art on a base garment); image -> Create mode
    // (use the picture as a starting material). Both open the same creator dialog.
    // H-131: imageId -> &source={images.id} (creator skips the hero act straight
    // into the gallery reveal); entry -> &entry=sources (create opens on the
    // source-picker act). H-140 action pipeline: designMaterial -> Design with
    // the material preselected at the Arts head; data-ref rides along as the
    // attribution token (hub writes the mms_ref cookie at boot).
    // H-140b: designBlank -> Design with the blank garment preselected
    // (homepage end-products Customize button, ref=home_product).
    // Params only — the open/close mechanism is untouched.
    function urlFor(opts) {
      opts = opts || {}
      let url = iframeUrl
      if (opts.designId) url += '&mode=design&design_id=' + encodeURIComponent(opts.designId)
      else if (opts.designMaterial)
        url += '&mode=design&design_material=' + encodeURIComponent(opts.designMaterial)
      else if (opts.designBlank)
        url += '&mode=design&design_blank=' + encodeURIComponent(opts.designBlank)
      else if (opts.productId) url += '&mode=design&product=' + encodeURIComponent(opts.productId)
      else if (opts.imageId) url += '&mode=create&source=' + encodeURIComponent(opts.imageId)
      else if (opts.imageUrl) url += '&mode=create&injectImage=' + encodeURIComponent(opts.imageUrl)
      else if (opts.entry) url += '&entry=' + encodeURIComponent(opts.entry)
      if (opts.ref) url += '&ref=' + encodeURIComponent(opts.ref)
      return url
    }

    // Full-page variant of urlFor (H-142 mobile redirect): same params and
    // attribution, but without embed=1 so the creator renders with its own
    // chrome (nav/dock) instead of the embedded shell.
    function fullPageUrlFor(opts) {
      return urlFor(opts).replace('?embed=1&', '?').replace('?embed=1', '')
    }

    function openModal(opts) {
      const want = urlFor(opts)
      // (Re)boot the iframe when first opening OR when a different product is
      // requested than the one currently loaded — so the design canvas always
      // reflects the product the shopper clicked from. The loader overlay covers
      // the iframe until its load event fires; we never toggle the iframe's own
      // hidden (a hidden iframe won't load → load never fires → infinite spin).
      if (iframe.src !== want) {
        loader.removeAttribute('hidden')
        iframe.src = want
        iframeBooted = true
        iframe.addEventListener(
          'load',
          function () {
            loader.setAttribute('hidden', '')
            sendAuth()
          },
          { once: true }
        )
      } else {
        loader.setAttribute('hidden', '')
      }
      if (typeof modal.showModal === 'function') {
        modal.showModal()
      } else {
        modal.setAttribute('open', '')
      }
    }

    function closeModal() {
      if (typeof modal.close === 'function') {
        modal.close()
      } else {
        modal.removeAttribute('open')
      }
    }

    // Event delegation: anything with data-mms-creator-modal-open triggers
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-mms-creator-modal-open]')
      if (trigger) {
        e.preventDefault()
        const opts = {
          productId: trigger.getAttribute('data-product-id') || '',
          imageUrl: trigger.getAttribute('data-image-url') || '',
          imageId: trigger.getAttribute('data-image-id') || '',
          designId: trigger.getAttribute('data-design-id') || '',
          designMaterial: trigger.getAttribute('data-design-material') || '',
          designBlank: trigger.getAttribute('data-design-blank') || '',
          entry: trigger.getAttribute('data-entry') || '',
          ref: trigger.getAttribute('data-ref') || '',
        }
        // H-142: mobile (Dawn 749px breakpoint) skips the modal and redirects
        // the top window to the full-page creator — window.top covers
        // nested-iframe embeds. fullPageUrlFor drops embed=1 (full chrome)
        // but keeps mode / design_blank / ref so the attribution chain holds.
        if (window.matchMedia('(max-width: 749px)').matches) {
          window.top.location.href = fullPageUrlFor(opts)
          return
        }
        openModal(opts)
        return
      }
      const closer = e.target.closest('[data-mms-creator-modal-close]')
      if (closer) {
        e.preventDefault()
        closeModal()
      }
    })

    // Receive signals from the creator iframe. creator-hub fires NAVIGATE after
    // saveDesign + Shopify product creation (design/shopify/index.js). We close
    // the modal and send the shopper to the freshly-created product PDP so they
    // can buy. Origin-checked + url-prefixed (open-redirect / SSRF guard).
    window.addEventListener('message', function (e) {
      if (e.origin !== iframeOrigin) return
      const data = e.data || {}
      // The creator's own X / ESC posts CLOSE when embedded — close the host
      // dialog so the popup fully dismisses (no leftover blank iframe window).
      if (data.type === 'CLOSE') {
        closeModal()
        return
      }
      if (
        data.type === 'NAVIGATE' &&
        typeof data.url === 'string' &&
        data.url.indexOf('https://mamamiya.store/') === 0
      ) {
        closeModal()
        window.location.href = data.url
      }
    })

    // Backdrop click (click on dialog element itself, not its inner content)
    modal.addEventListener('click', function (e) {
      const rect = modal.getBoundingClientRect()
      const inDialog =
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom
      // dialog.click fires when clicking the backdrop; only close on backdrop
      if (e.target === modal && !inDialog) closeModal()
    })

    // SDS SDK warm-up, two tiers, fired on idle after the homepage paints.
    //
    // Tier 1 (cheap, always): preconnect to the creator + sign origins and
    // prefetch the ~788KB SDK bundle — the first click skips DNS/TLS + download.
    //
    // Tier 2 (deep, desktop only): boot creator in an OFF-SCREEN iframe so its
    // SPA bundle, the SDS SDK AND the sign cert are fetched, and creator's own
    // preloadDesigner ghost-inits the SDK right now (it needs a sized container,
    // which a real off-screen iframe provides but a display:none dialog can't).
    // The first real Customize/Create click then opens against a fully warmed
    // creator. Cost: every desktop homepage visitor loads creator in the
    // background (~1-2MB + one /api/sdk/sign). Disable by removing the Tier 2
    // block if that traffic/quota cost outweighs the speed-up.
    function warmUp() {
      var specs = [
        ['preconnect', iframeOrigin],
        ['dns-prefetch', 'https://admin-api.mamamiya.store'],
        ['preconnect', 'https://admin-api.mamamiya.store'],
        ['prefetch', iframeOrigin + '/lib/sds-sdk.js'],
      ]
      specs.forEach(function (s) {
        if (document.head.querySelector('link[data-mms-warm="' + s[1] + s[0] + '"]')) return
        var l = document.createElement('link')
        l.rel = s[0]
        l.href = s[1]
        l.setAttribute('data-mms-warm', s[1] + s[0])
        if (s[0] === 'preconnect' || s[0] === 'prefetch') l.crossOrigin = 'anonymous'
        if (s[0] === 'prefetch') l.as = 'script'
        document.head.appendChild(l)
      })

      // Tier 2 — off-screen creator boot. Mobile redirects to the full-page
      // creator (H-142), so the modal prewarm is wasted there — skip it.
      if (window.matchMedia('(max-width: 749px)').matches) return
      if (document.querySelector('iframe[data-mms-creator-prewarm]')) return
      var warm = document.createElement('iframe')
      warm.src = iframeUrl // ?embed=1, no product — just warm resources + SDK
      warm.setAttribute('data-mms-creator-prewarm', '')
      warm.setAttribute('aria-hidden', 'true')
      warm.setAttribute('tabindex', '-1')
      warm.title = 'creator prewarm'
      warm.style.cssText =
        'position:fixed;left:-99999px;top:0;width:1200px;height:800px;border:0;opacity:0;pointer-events:none'
      // Lifecycle: once it has loaded + had time to cache the SPA, the SDK bundle
      // and the sign cert (and ghost-init the SDK), tear the prewarm iframe down.
      // The HTTP cache persists so the first real click is still fast, but we
      // don't keep a hidden creator instance (memory + sockets) alive forever.
      warm.addEventListener(
        'load',
        function () {
          setTimeout(function () {
            var w = document.querySelector('iframe[data-mms-creator-prewarm]')
            if (w && w.parentNode) w.parentNode.removeChild(w)
          }, 20000)
        },
        { once: true }
      )
      document.body.appendChild(warm)
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(warmUp, { timeout: 3000 })
    } else {
      setTimeout(warmUp, 1500)
    }
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mms-material-card"] && !Shopify.designMode) return;
  try {
    ;(function () {
    'use strict'
    if (!window.MMY || window.MMY.materialCard) return

    // Icons come from the theme's existing phosphor set (regular weight,
    // loaded once in theme.liquid) — no inline SVG, no new icon library.
    var ICONS = {
      brush: '<i class="ph ph-paint-brush" aria-hidden="true"></i>',
      design: '<i class="ph ph-palette" aria-hidden="true"></i>',
      download: '<i class="ph ph-download-simple" aria-hidden="true"></i>',
      heart: '<i class="ph ph-heart" aria-hidden="true"></i>',
      share: '<i class="ph ph-share-network" aria-hidden="true"></i>',
    }

    var FAVORITES_KEY = 'mms_favorites'

    function esc(t) {
      return window.MMY && window.MMY.escapeHtml ? window.MMY.escapeHtml(t) : String(t || '')
    }

    function readFavorites() {
      try {
        var raw = localStorage.getItem(FAVORITES_KEY)
        var ids = raw ? JSON.parse(raw) : []
        return Array.isArray(ids) ? ids.map(String) : []
      } catch (_) {
        return []
      }
    }

    function writeFavorites(ids) {
      try {
        localStorage.setItem(FAVORITES_KEY, JSON.stringify(ids))
      } catch (_) {
        /* private mode — favorite state simply does not persist */
      }
    }

    /**
     * Build the standard material card HTML.
     * item: { id, url, thumbnail_url, title, artist, sharing_authorized }
     * opts: { section } — tracking label. Extra action surfaces (H-124
     * community picks) reuse this verbatim; the sharing_authorized=false
     * rule hides 分享 (A5 scraped-asset compliance).
     */
    function materialCard(item, opts) {
      opts = opts || {}
      var M = window.MMY
      var id = item && item.id != null ? String(item.id) : ''
      var rawUrl = (item && (item.thumbnail_url || item.url)) || ''
      var src = M && M.cdnVariant ? M.cdnVariant(rawUrl, 'card') : rawUrl
      var artist = (item && item.artist) || 'mamamiya'
      var title = (item && item.title) || 'artwork'
      // Field absent on the anon feed = curated (the feed itself is
      // sharing-safe by construction); only an explicit false hides 分享.
      var shareable = !(item && item.sharing_authorized === false)
      var isFav = readFavorites().indexOf(id) !== -1

      var buttons =
        '<button type="button" class="mms-mat-card__btn mms-mat-card__btn--design" data-mat-action="design"' +
        ' data-mms-creator-modal-open data-design-material="' + esc(id) + '" data-ref="gallery_design"' +
        ' aria-label="用「' + esc(title) + '」开始设计">' + ICONS.design + ' 设计</button>' +
        '<button type="button" class="mms-mat-card__btn" data-mat-action="download" aria-label="下载「' + esc(title) + '」">' + ICONS.download + ' 下载</button>' +
        '<button type="button" class="mms-mat-card__btn" data-mat-action="favorite" aria-pressed="' + (isFav ? 'true' : 'false') + '"' +
        ' aria-label="' + (isFav ? '取消收藏' : '收藏') + '「' + esc(title) + '」">' + ICONS.heart + ' <span data-mat-fav-label>' + (isFav ? '已收藏' : '收藏') + '</span></button>' +
        (shareable
          ? '<button type="button" class="mms-mat-card__btn" data-mat-action="share" aria-label="分享「' + esc(title) + '」">' + ICONS.share + ' <span data-mat-share-label>分享</span></button>'
          : '')

      return (
        '<figure class="mms-mat-card" data-mat-id="' + esc(id) + '" data-mat-url="' + esc(rawUrl) + '"' +
        ' data-mat-title="' + esc(title) + '" tabindex="0" role="group"' +
        ' data-mms-creator-modal-open data-image-id="' + esc(id) + '" data-ref="gallery"' +
        ' aria-label="' + esc(title) + ', by ' + esc(artist) + '">' +
        '<img class="mms-mat-card__img" src="' + esc(src) + '" alt="' + esc(title) + '" loading="lazy" width="400" height="533">' +
        '<span class="mms-mat-card__sig">' + ICONS.brush + '<span>' + esc(artist) + '</span></span>' +
        '<span class="mms-mat-card__actions">' + buttons + '</span>' +
        '</figure>'
      )
    }

    function track(action, card, source) {
      var M = window.MMY
      if (!M || !M.track) return
      M.track(action, card.dataset.matId, {
        item_type: 'image',
        section: 'material_card',
        source: source,
      })
    }

    // Whole-card intent = Create with the image as source (see → like →
    // generate, exploratory). The card body itself carries the modal trigger
    // attributes (data-mms-creator-modal-open + data-image-id + ref=gallery),
    // so a real tap — or this synthetic click for keyboard parity — routes
    // through the creator-modal's own document delegation. The 设计 button
    // stays the commitment action (direct to Design via design_material).
    function openCreateEntry(card) {
      card.click()
    }

    function onDownload(card) {
      var M = window.MMY
      var url = M && M.cdnVariant ? M.cdnVariant(card.dataset.matUrl, 'detail') : card.dataset.matUrl
      track(M.TRACK_EVENTS.CLICK, card, 'download')
      if (url) window.open(url, '_blank', 'noopener')
    }

    function onFavorite(card, btn) {
      var id = card.dataset.matId
      var ids = readFavorites()
      var idx = ids.indexOf(id)
      var nowFav = idx === -1
      if (nowFav) ids.push(id)
      else ids.splice(idx, 1)
      writeFavorites(ids)
      btn.setAttribute('aria-pressed', nowFav ? 'true' : 'false')
      // The heart icon stays put; the pressed state is recolored via the
      // [aria-pressed='true'] rule (accent red, Pinterest-style).
      var label = btn.querySelector('[data-mat-fav-label]')
      if (label) label.textContent = nowFav ? '已收藏' : '收藏'
      track(window.MMY.TRACK_EVENTS.CLICK, card, nowFav ? 'favorite' : 'unfavorite')
    }

    function onShare(card, btn) {
      var M = window.MMY
      var url = M && M.cdnVariant ? M.cdnVariant(card.dataset.matUrl, 'detail') : card.dataset.matUrl
      var payload = { title: card.dataset.matTitle || 'mamamiya artwork', url: url }
      track(M.TRACK_EVENTS.CLICK, card, 'share')
      function copied() {
        var label = btn.querySelector('[data-mat-share-label]')
        if (!label) return
        label.textContent = '已复制'
        setTimeout(function () {
          label.textContent = '分享'
        }, 1600)
      }
      if (navigator.share) {
        navigator.share(payload).catch(function () {})
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(copied).catch(function () {})
      }
    }

    /**
     * Delegate card behavior inside `root`. Idempotent per root node.
     * Both entries ride the creator-modal's document-level delegation: the
     * 设计 button carries data-design-material + ref=gallery_design (direct to
     * Design), the card body carries data-image-id + ref=gallery (Create with
     * the image as source) — no duplicate wiring here. Utility actions
     * (download/favorite/share) stop propagation so their clicks never bubble
     * up into the card body's modal trigger.
     */
    function bindMaterialCards(root) {
      if (!root || root.dataset.mmsMatBound) return
      root.dataset.mmsMatBound = '1'

      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mat-action]')
        var card = e.target.closest('.mms-mat-card')
        if (!card || !root.contains(card)) return
        if (btn) {
          var action = btn.dataset.matAction
          // 'design' falls through to the creator-modal delegation (the button
          // carries its own trigger attributes).
          if (action === 'design') return
          e.stopPropagation()
          if (action === 'download') onDownload(card)
          if (action === 'favorite') onFavorite(card, btn)
          if (action === 'share') onShare(card, btn)
          return
        }
        // Card body click: bubbles to the creator-modal delegation via the
        // figure's own trigger attributes — nothing to wire here.
      })

      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return
        var card = e.target.closest('.mms-mat-card')
        // Native button activation handles action buttons; the card body
        // itself maps Enter/Space to the Create entry.
        if (!card || e.target !== card) return
        e.preventDefault()
        openCreateEntry(card)
      })
    }

    window.MMY.materialCard = materialCard
    window.MMY.bindMaterialCards = bindMaterialCards
  })()
  } catch(e) { console.error(e); }
})();

})();
